import { staticListProductListStyles as styles } from "@dillon/Overrides/Widgets/StaticList/StaticListProductList";
import { colorStrings, mediaQueriesBP } from "@dillon/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.lineInnerContainer = {
    gap: 10, 
}

styles.linesWrapper = {
    css: css`
        margin-top: 10px;
        border-top: 1px solid ${getColor(colorStrings.commonGlobalGray03)};
    `,
}

styles.imageWrapper = {
    css: css`
    @media print {
        max-height: 83px;
        max-width: 83px;
    }
    width: 100%;
    min-width: 0;
    flex-direction: column;
`,
}

styles.linkWrappingImage = {
    css: css`
        width: 100%;
    `
}

styles.img = {
    css: css`
        height: auto;
        width: 100%;
    `
}

styles.imageGridItem = {
    width: [3, 3, 2, 2, 1],
    printWidth: 1,
}

styles.descriptionGridItem = {
    width: [8, 8, 4, 4, 4],
    printWidth: 6,
    css: css`
        flex-direction: column;
    `,
}

styles.accordionSection = {
    css: css`
        border-bottom: 1px lightgray solid;
        padding: 20px 15px;
    `,
}

styles.accordionHeader = {
    css: css`
        ${mediaQueriesBP.minMD} {
            margin-block: 10px;

            button {
                padding-inline: 5px;
            }
        }

        button {
            background-color: transparent;
            border: none;
            align-items: flex-start;
        }
    `,
}

styles.accordionPanel = {
    css: css`
        border: none;
        padding-bottom: 0;

        ${mediaQueriesBP.minMD} {
            padding-inline: 40px 0;
        }

        &:not([hidden]) {
            margin-top: 10px;
            border-top: 1px solid ${getColor(colorStrings.commonGlobalGray03)};
        }

        & > div:last-child {
            border-bottom: none;
        }
    `,
}